/** PrimeFlex layout breakpoints compatible with CDK BreakpointObserver */
export const PrimeFlexBreakpoints = {
  XSmall: '(max-width: 575.98px)',
  Small: '(min-width: 576px) and (max-width: 767.98px)',
  Medium: '(min-width: 768px) and (max-width: 991.98px)',
  Large: '(min-width: 992px) and (max-width: 1199.98px)',
  XLarge: '(min-width: 1200px)',
} as const;
